<template>
    <yuukyuukanri-list />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import YuukyuukanriList from '@/components/yuukyuukanri/Search.vue'
import { useYuukyuuKanriStore } from "@/store/yuukyuu-kanri";
import { RouterConst } from "@/const/Router";
import { onBeforeRouteLeave } from 'vue-router';
export default defineComponent({
  beforeRouteEnter(to, from, next){
    next(vm => {
      const yuukyuuKanriStore = useYuukyuuKanriStore();
      if(from.name != RouterConst.YUUKYUU_KANRI_DETAIL){
        // 検索情報の削除
        yuukyuuKanriStore.removeItem();
      }
    });
  },
  setup() {
    const yuukyuuKanriStore = useYuukyuuKanriStore();
    onBeforeRouteLeave((to, from, next) => {
      if(to.name != RouterConst.YUUKYUU_KANRI_DETAIL){
        // 検索情報の削除
        yuukyuuKanriStore.removeItem();
      }
      next()
    })

    return {}
  },
  components: {
    'yuukyuukanri-list': YuukyuukanriList
  }
})
</script>
